export default __webpack_public_path__ + "static/media/video1.377796e6.webp";